import React from 'react';
import { default as Notification } from '../../../../../BaseComponents/Notification';
import { useTheme } from '../../../../../theme';
import cn from 'classnames';
const ExchangeRefundOrderRequestStatus = ({ className, status, title, text, actionText, onClickAction }) => {
    const { ExchangeRefundOrderRequestStatus: theme } = useTheme('Entities').Order;
    return (React.createElement(Notification, { className: cn(theme.notification, className, { [theme.done]: status === 'done' }), globalClassName: theme.notificationGlobal, actionClassName: theme.action, type: 'global', status: status, title: title, text: text, actionText: actionText, onClickAction: onClickAction }));
};
export default ExchangeRefundOrderRequestStatus;
